import { Dispatch, SetStateAction, useEffect } from 'react';
import styles from './FieldOffer.module.scss';
import { AttachmentsDetailsError, NamesOfFieldEnum, Offer } from '~/typings/types';
import { Field, FormSpy } from 'react-final-form';
import { FormField } from '~/pages/questionnaires/shared';
import { ErrorField, RadioField } from '~/components';
import { DocumentPreview } from './document-preview';
import { ERROR_FIELD_ } from '~/configs/consts';

interface FieldOffer {
	clientId: string;
	isUploadOffer: boolean;
	setIsUploadOffer: Dispatch<SetStateAction<boolean>>;
	errorUploadOffer: AttachmentsDetailsError;
	setErrorUploadOffer: Dispatch<AttachmentsDetailsError>;
	typeOffer: "custom" | "default";
	offer?: Offer;
	textLinkOffer: string;
	setTextLinkOffer: Dispatch<SetStateAction<string>>;
	isGeneratedOffer: boolean;
	setIsGeneratedOffer: Dispatch<SetStateAction<boolean>>;
	titleField?: string;
	shouldRenderTitleAboveField?: boolean;
	required?: boolean;
}

export const FieldOffer = ({ clientId, isUploadOffer, setIsUploadOffer, errorUploadOffer, setErrorUploadOffer, typeOffer, offer, textLinkOffer, setTextLinkOffer, isGeneratedOffer, setIsGeneratedOffer, titleField, shouldRenderTitleAboveField = false, required = false }: FieldOffer) => {
	return (
		<FormSpy subscription={{ values: true }}>
			{propsSpy => (
				<>
					<FormField
						titleField={titleField}
						name={NamesOfFieldEnum.Offer}
						styleContainerTitleField={{ width: "96%" }}
						showError={false}
						required={required}
						shouldRenderTitleAboveField={shouldRenderTitleAboveField}
					>
						<div id={errorUploadOffer?.has ? `${ERROR_FIELD_}offer` : undefined}>
							<p style={{ fontSize: '12px', color: '#D32F2F', marginBottom: 4 }}>ВАЖНО:</p>
							<ul className={styles.listRequired}>
								<li>Добавьте свою оферту или воспользуйтесь нашим шаблоном оферты.</li>
							</ul>
							<div className={styles.containerRadio}>
								<Field
									name={NamesOfFieldEnum.OfferType}
									type="radio"
									value="custom"
									component={props => <RadioField   {...props} classNameWrapper={styles.radioBtn} />}
								>
									У меня есть своя оферта
								</Field>
								<Field
									name={NamesOfFieldEnum.OfferType}
									type="radio"
									value="default"
									component={props => <RadioField   {...props} classNameWrapper={styles.radioBtn} />}
								>
									У меня нет оферты
								</Field>
							</div>
						</div>
					</FormField>
					{(propsSpy.values?.[NamesOfFieldEnum.OfferType] === "custom") && (
						<FormField
							titleField={""}
							name={"custom"}
							isColon={false}
							required
							styleContainerTitleField={{ width: "96%" }}
							shouldRenderTitleAboveField
							showError={false}
						>
							<div className={styles.containerRadio}>
								<DocumentPreview
									clientId={clientId}
									isUploadOffer={isUploadOffer}
									setIsUploadOffer={setIsUploadOffer}
									errorUploadOffer={errorUploadOffer}
									setErrorUploadOffer={setErrorUploadOffer}
									typeOffer="custom"
									offer={offer}
									textLinkOffer={textLinkOffer}
									setTextLinkOffer={setTextLinkOffer}
									setIsGeneratedOffer={setIsGeneratedOffer}
								/>
							</div>
						</FormField>
					)}
					{(propsSpy.values?.[NamesOfFieldEnum.OfferType] === "default") && (
						<FormField
							titleField={""}
							name={"default"}
							isColon={false}
							styleContainerTitleField={{ width: "96%" }}
							shouldRenderTitleAboveField
							showError={false}
						>
							<div className={styles.containerRadio}>
								<DocumentPreview
									clientId={clientId}
									isUploadOffer={isUploadOffer}
									setIsUploadOffer={setIsUploadOffer}
									errorUploadOffer={errorUploadOffer}
									setErrorUploadOffer={setErrorUploadOffer}
									typeOffer="default"
									offer={offer}
									textLinkOffer={textLinkOffer}
									setTextLinkOffer={setTextLinkOffer}
									setIsGeneratedOffer={setIsGeneratedOffer}
								/>
							</div>
						</FormField>
					)}
					{<ErrorField
						name="offer-custom"
						classNameContainer={styles.errorFieldWithIncreasedSpacing}
						renderError={
							errorUploadOffer
								? errorUploadOffer
								: (isUploadOffer || isGeneratedOffer || offer?.type === "default")
									? {
										has: 1,
										message: "Ваша оферта принята.\n После подключения к системе мы разместим её на платежной странице и вышлем на почту.",
										color: "#437a54"
									}
									: undefined
						} />
					}
				</>
			)}
		</FormSpy>
	)
};